import React from 'react';

function PosTerminalIcon({ width = 30, height = 40 }){
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="vendor-list-svg-icon"
        >
            <path
                d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v4h10V4H7zm0 6v10h10V10H7z"
                fill="#6D7383"
                className="fill-red"
            />
            <path
                d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v4h10V4H7zm0 6v10h10V10H7z"
                className="fill-red"
            />
            <path
                d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v4h10V4H7zm0 6v10h10V10H7z"
                className="fill-red"
            />
            <path
                d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v4h10V4H7zm0 6v10h10V10H7z"
                className="fill-red"
            />
        </svg>
    );
}

export default PosTerminalIcon;
